module.exports = __webpack_public_path__ + "img/20200512_161628.bd2a0b91.jpg";